import { useLoadingStore } from 'src/stores/loading';

import { Callback } from 'src/util/query/models/Callback';

export class SendTheDocumentViaMailQueryCallback extends Callback<Blob> {
	private readonly onDocumentContentLoaded: (documentContent: Blob) => void;

	constructor(onDocumentContentLoaded: (documentContent: Blob) => void) {
		super();
		this.onDocumentContentLoaded = onDocumentContentLoaded;
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		useLoadingStore().hide();
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Blob): void => {
		useLoadingStore().hide();
		this.onDocumentContentLoaded(successResponse);
	};
}
